export const GET_CLAIMABLE = 'referrer/getClaimable';
export const CLAIM_REWARD = 'referrer/claimReward';
export const GET_USER_REFERRALS = 'referrer/getUserReferrals';
export const GET_REFERRALS_LENGTH = 'referrer/getReferralLength';

export const actionTypes = {
  GET_CLAIMABLE,
  CLAIM_REWARD,
  GET_USER_REFERRALS,
  GET_REFERRALS_LENGTH,
};
